import {MAX_FILE_SIZE} from 'constants/file/fileSizes';

export const CODE_FILE_UNDEFINED_ERROR = 0 as const;
export const CODE_FILE_SIZE_ERROR = 1 as const;
export const CODE_FILE_TYPE_ERROR = 2 as const;

export const FILE_ERROR_MESSAGE = {
    '0': 'Please upload file with prescription',
    '1': `File size is too big. Max file size ${
        Number.isInteger(MAX_FILE_SIZE) ? MAX_FILE_SIZE / 1024 / 1024 : 7
    }MB`,
    '2': 'This file type is not supported, try to upload a PDF, document or an image.',
};
